import { getTranscriptFontScale } from 'src/models/UIConfiguration'

export const TRANSCRIPT_HIGHLIGHT = 'transcript-highlight'

// The base layer other transcript highlights stack against: the word being played paints above it.
// Never give a second highlight this same value: the overlap would go to whichever re-registered last.
export const TRANSCRIPT_HIGHLIGHT_PRIORITY = 0

export const PLAYBACK_HIGHLIGHT = 'playback-highlight'

export const PLAYBACK_HIGHLIGHT_PRIORITY = 1

// The inconsistency icon and its offset scale with the transcript font, as the time and speaker beside it do, up to
// twice their size: past that the room they take beside the paragraph would squeeze a phone's text to a few words
// per line. The transcript viewer sets this variable from `getInconsistencyIndicatorScale`.
export const INCONSISTENCY_INDICATOR_SCALE_VAR = '--inconsistency-indicator-scale'
export const scaleWithFont = (px: number) => `calc(${px}px * var(${INCONSISTENCY_INDICATOR_SCALE_VAR}, 1))`

const MAX_INCONSISTENCY_INDICATOR_SCALE = 2

export const getInconsistencyIndicatorScale = (fontSizePercentage: number) =>
    Math.min(getTranscriptFontScale(fontSizePercentage), MAX_INCONSISTENCY_INDICATOR_SCALE)
